'use strict';

goog.provide("Ntry.CfestResult");

goog.require("Ntry.STATIC");
goog.require("Ntry.Engine");

Ntry.CfestResult = function() {
    this._view = Ntry.interfaceManager.getDom('ntryResultArea');
    this.createDom();
};

(function(p){

    p.createDom = function () {
        var that = this;
        var parent = this._view;
        var container = Ntry.createElement('div', parent, null, 'ntryResultContainer');
        var title = Ntry.createElement('div', container, null, 'ntryResultTitle')
        this._closeButton = Ntry.createElement('span', title, null, 'ntryResultCloseButton');
        this._closeButton.innerHTML = Lang.Menus.close;

        var content = Ntry.createElement('div', container, null, 'ntryResultContent');
        this._leftImg = Ntry.createElement('div', content, null, 'ntryResultLeftImg');

        var rightDiv = Ntry.createElement('div', content, null, 'ntryResultRightDiv');
        this._successContent = Ntry.createElement('div', rightDiv, null, 'ntryResultRightContent');

        this._usedBlockPrefix = Ntry.createElement('span', this._successContent, null, 'ntryResultContentSpan');
        this._usedBlockCnt = Ntry.createElement('span', this._successContent, null, 'ntryResultBlockCnt');
        this._usedBlockSuffix = Ntry.createElement('span', this._successContent, null, 'ntryResultContentSpan');

        this._limitBlockPrefix = Ntry.createElement('span', this._successContent, null, 'ntryResultContentSpan');
        this._limitBlockCnt = Ntry.createElement('span', this._successContent, null, 'ntryResultBlockCnt');
        this._limitBlockSuffix = Ntry.createElement('span', this._successContent, null, 'ntryResultContentSpan');

        this._certLink = Ntry.createElement('div', this._successContent, null, 'ntryResultContentCert', 'ntryRemove');
        this._certLink.innerHTML = Lang.Menus.close_experience;

        this._failContent = Ntry.createElement('div', rightDiv, null, 'ntryResultRightContent');
        this._failCauseString = Ntry.createElement('span', this._failContent, null, 'ntryResultFailCauseSpan');
        this._essentialBlocks = Ntry.createElement('div', this._failContent, null, 'ntryResultEssentialBlocks');

        this._replayButton = Ntry.createElement('span', content, null, 'ntryResultReplayButton');
        this._replayButton.innerHTML = Lang.Menus.replay;

        this._nextButton = Ntry.createElement('span', content, null, 'ntryResultNextButton');
        this._nextButton.innerHTML = Lang.Menus.go_to_next_level;
        this._nextButton.bindOnClick(function() {
            Ntry.goToUrl(that._nextLink);
        });
    };

    p.update = function() {
    };

    p.loadConfig = function () {
        Ntry.addEventListener("complete", this, this.complete);
    };

    p.complete = function(success, cause) {
        var stageId = Ntry.configManager.getConfig("stageId");
        if (stageId)
            stageId = Number(stageId);

        this._leftImg.removeClasses();
        this._leftImg.addClass('ntryResultLeftImg');



        var self = this;
        this._closeButton.bindOnClick(function() {
            $(self._view).css('display', 'none');
        });

        this._replayButton.bindOnClick(function() {
            Ntry.dispatchEvent("replay");
            $(self._view).css('display', 'none');
        });

        this._nextLink = '/we/cfest#!/'+(stageId+1);

        this._certLink.bindOnClick(function() {
            window.location.href = '/we/cfest#!/1';
        });

        if (success) {
            var isEssentialUsed = this.inspectEssential();
            if (isEssentialUsed) {
                this.success(stageId);
            } else {
                this.fail(stageId, Ntry.STATIC.ESSENTIAL_REQUIRED);
            }
        } else {
            this.fail(stageId, cause);
        }

        $(this._view).css('display', 'block');
    };

    p.inspectEssential = function() {
        var essentialBlockInfo = Ntry.configManager.getConfig('essentialBlockInfo');
        if (_.isEmpty(essentialBlockInfo)) return true;

        var entityManager = Ntry.entityManager;
        var entities = entityManager.getEntitiesByComponent(Ntry.STATIC.SCRIPT_CONTAINER);
        if (_.isEmpty(entities)) return false;;

        var restoreComp = entityManager.getComponent(_.first(_.keys(entities)),
                    Ntry.STATIC.RESTORE);
        if (!restoreComp) return true;

        var restoreScript = Blockly.mainWorkspace.getTopBlocks(Blockly.mainWorkspace);
        if (!restoreScript) return true;

        var blocks = _.filter(restoreScript, function(b){
            var type = b.type;
            var headBlocks = [
                'ai_start',
                'ai_start_un',
                'maze_step_start',
                'maze_step_unstart',
                'maze_define_unfunction',
                'maze_define_function'
            ];
            return headBlocks.indexOf(type) > -1;
        });

        restoreScript = _.reduce(blocks, function(a,b){
            var txt = Blockly.Xml.domToText(Blockly.Xml.blockToDom_(b));
            return a + txt;
        }, '');

        /* inspect all essentialBlocks pass regex for
         * restore block script
        */
        var matchCnt = 0;
        for (var i=0,len=essentialBlockInfo.blocks.length; i<len; i++) {
            if (new RegExp(essentialBlockInfo.blocks[i], 'i').test(restoreScript))
                matchCnt++;
        };

        return matchCnt >= essentialBlockInfo.matchCnt;
    };

    function getImgLang() {
        var cookieVal = document.cookie.split('lang=');

        if(cookieVal.length <= 0)
            return 'ntryResultSuccessImg';

        for(var i=0; i< cookieVal.length; i++){
            var tempcookie = cookieVal[i];
            if (tempcookie.substring(0,2) == 'en') {
                return 'ntryResultSuccessImgEn';
            }
        }
        return 'ntryResultSuccessImg';
    };

    p.success = function(stageId) {
        var limitBlockCnt = Ntry.configManager.getConfig("limitBlockCnt");
        var usedBlockCnt = Ntry.countUsedBlocks();

        this._leftImg.addClass(getImgLang());
        this._replayButton.removeClass('ntryResultReplayButtonFailed');
        this._replayButton.removeClass('ntryResultFailAndReply');
        if (stageId === 6)
            this._replayButton.addClass('ntryResultFailAndReply');
        else
            this._replayButton.addClass("ntryResultReplayButtonFailed");

        this._usedBlockCnt.innerHTML = usedBlockCnt;
        this._limitBlockCnt.innerHTML = limitBlockCnt;
        if (usedBlockCnt === limitBlockCnt) {
            this._usedBlockPrefix.innerHTML = Lang.Menus.perfect;
            this._usedBlockSuffix.innerHTML = Lang.Menus.succeeded_using_blocks;
            this._limitBlockCnt.ntryRemove();
            this._limitBlockPrefix.ntryRemove();
            this._limitBlockSuffix.ntryRemove();
        } else if (usedBlockCnt < limitBlockCnt) {
            this._usedBlockPrefix.innerHTML = Lang.Menus.awesome;
            this._usedBlockSuffix.innerHTML = Lang.Menus.succeeded_go_to_next;
            this._limitBlockCnt.ntryRemove();
            this._limitBlockPrefix.ntryRemove();
            this._limitBlockSuffix.ntryRemove();
            this._replayButton.ntryRemove();
        } else {
            this._usedBlockPrefix.innerHTML = Lang.Menus.good;
            this._usedBlockSuffix.innerHTML = Lang.Menus.succeeded_using_blocks;
            this._limitBlockPrefix.innerHTML = Lang.Menus.but;
            this._limitBlockSuffix.innerHTML = Lang.Menus.try_again;
            this._limitBlockCnt.ntryShow('ntryShowInlineBlock');
            this._limitBlockPrefix.ntryShow('ntryShowInline');
            this._limitBlockSuffix.ntryShow('ntryShowInline');
        }

        if (stageId === 6) {
            this._usedBlockCnt.ntryRemove();
            this._usedBlockPrefix.ntryRemove();
            this._usedBlockSuffix.innerHTML = Lang.Menus.cfest_success;
            this._certLink.ntryShow();
            this._replayButton.ntryShow();
            this._nextButton.ntryRemove();

        } else {
            this._nextButton.ntryShow();
        }

        /*
         * do not save the user script for cFest
        var playerData = NtryDataCfest.player[stageId];
        var script = Blockly.Xml.workspaceToDom(Blockly.mainWorkspace)
        playerData.userScript = Blockly.Xml.domToText(script);
        */
        this._successContent.ntryShow();
        this._failContent.ntryRemove();

    };

    p.fail = function(stageId, cause) {
        var theme = 1;

        if (stageId <= 6)
            theme = 1;
        else if (stageId <= 14)
            theme = 2;
        else
            theme = 3;

        var causeString = '';
        var causeStyle = 1;

        var causeMsgs = [
            Lang.Menus.cause_msgs_1,
            Lang.Menus.cause_msgs_2,
            Lang.Menus.cause_msgs_3,
            Lang.Menus.cause_msgs_4,
            Lang.Menus.cause_msgs_5
        ]

        this._essentialBlocks.removeClasses();
        this._essentialBlocks.ntryRemove();

        switch (cause) {
            case Ntry.STATIC.JUMP:
                causeString = causeMsgs[1];
                causeStyle = 1;
                break;

            case Ntry.STATIC.SIMOOROOK:
                causeString = causeMsgs[4];
                causeStyle = 1;
                break;

            case Ntry.STATIC.WALL_CRASH:
                causeString = causeMsgs[0];
                causeStyle = 2;
                break;

            case Ntry.STATIC.BEE_ATTACK:
                causeString = causeMsgs[2];
                causeStyle = 3;
                break;

            case Ntry.STATIC.ELECTRIC_SHOCK:
                causeString = causeMsgs[2];
                causeStyle = 3;
                break;

            case Ntry.STATIC.SLIP:
                causeString = causeMsgs[2];
                causeStyle = 3;
                break;

            case Ntry.STATIC.ESSENTIAL_REQUIRED:
                causeString = causeMsgs[3];
                causeStyle = 1;
                this.renderBlocks(stageId);
                break;

            default:
                causeString = causeMsgs[4];
                causeStyle = 1;

        }

        var imageClass = 'ntryResultFailCfest';

        this._leftImg.addClass(imageClass);
        this._failCauseString.innerHTML = causeString;

        this._successContent.ntryRemove();
        this._failContent.ntryShow();

        this._nextButton.ntryRemove();
        this._replayButton.addClass('ntryResultFailAndReply');

    };

    p.renderBlocks = function(stageId) {
        var type = 5;
        if (stageId === 3 || stageId === 4)
            type = 6;
        else if(stageId === 5 || stageId === 6)
            type = 7;
        else if (stageId === 7 || stageId === 8)
            type = 1;
        else if (stageId === 9)
            type = 2;
        else if (stageId >= 10 && stageId <= 12)
            type = 3;
        else if (stageId === 13 || stageId === 14)
            type = 4;

        this._essentialBlocks.removeClasses();
        this._essentialBlocks.addClass("ntryResultEssentialBlocks");
        this._essentialBlocks.addClass("ntryResultEssentialBlock_"+type);
    };

})(Ntry.CfestResult.prototype);
